import { ReactNode, useState } from "react";
import { Button } from "trunx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faTimes } from "@fortawesome/free-solid-svg-icons";

interface SensorLegendControlsProps {
  children: ReactNode;
  collapsible?: boolean;
  dataCy: string;
}

const SensorLegendControls = ({
  children,
  collapsible,
  dataCy,
}: SensorLegendControlsProps) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div
      className={`sensor-legend-controls${collapsed ? " is-collapsed" : ""}`}
    >
      <div
        className="buttons has-addons sensor-measure-toggle"
        data-cy={dataCy}
      >
        {children}
      </div>
      {collapsible && (
        <Button
          className="sensor-panel-close sensor-legend-close"
          bulma={["has-text-white", "is-ghost"]}
          aria-label={collapsed ? "Expand legend" : "Collapse legend"}
          aria-expanded={!collapsed}
          onClick={() => setCollapsed((value) => !value)}
        >
          <FontAwesomeIcon icon={collapsed ? faChevronUp : faTimes} />
        </Button>
      )}
    </div>
  );
};

export default SensorLegendControls;
